import React, { useEffect, useState, useCallback } from "react";
import AdminSidebar from "../../components/AdminSidebar";
import { useToast } from "../../components/Toast.jsx";
import "./admin.css";

export default function AdminFmsRequests() {
  const toast = useToast();
  const [fmsAccounts, setFmsAccounts] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState("");

  const API = process.env.REACT_APP_API_URL;
  const token = localStorage.getItem("token");

  const loadFms = useCallback(async () => {
    try {
      setLoading(true);
      setError("");
      const res = await fetch(`${API}/api/admin/fms/all`, {
        headers: { Authorization: `Bearer ${token}` }
      });
      if (!res.ok) {
        setError("Failed to load FMS accounts");
        return;
      }
      setFmsAccounts(await res.json());
    } catch (err) {
      setError("Server error while loading FMS accounts");
    } finally {
      setLoading(false);
    }
  }, [API, token]);

  useEffect(() => {
    loadFms();
  }, [loadFms]);

  const handleApprove = async (id) => {
    try {
      const res = await fetch(`${API}/api/admin/fms/approve/${id}`, {
        method: "POST",
        headers: { Authorization: `Bearer ${token}` }
      });
      if (!res.ok) throw new Error("Failed to approve");
      setFmsAccounts((prev) => prev.filter((f) => f.id !== id));
      toast.success("FMS account approved successfully");
    } catch (err) {
      toast.error("Error: " + err.message);
    }
  };

  const handleReject = async (id) => {
    try {
      const res = await fetch(`${API}/api/admin/fms/reject/${id}`, {
        method: "POST",
        headers: { Authorization: `Bearer ${token}` }
      });
      if (!res.ok) throw new Error("Failed to reject");
      setFmsAccounts((prev) => prev.filter((f) => f.id !== id));
      toast.success("FMS account rejected successfully");
    } catch (err) {
      toast.error("Error: " + err.message);
    }
  };

  return (
    <div className="admin-layout">
      <AdminSidebar />

      <div className="admin-content">
        <h1>FMS Team Requests</h1>
        <p className="admin-sub">Approve or reject Facility Management staff sign-ups</p>

        {/* Content */}
        {error && <div className="admin-error">{error}</div>}

        {loading ? (
          <div className="admin-loading">Loading FMS accounts...</div>
        ) : fmsAccounts.length === 0 ? (
          <div className="admin-empty">
            No FMS accounts registered yet
          </div>
        ) : (
          <div className="residents-table-wrapper">
            <table className="residents-table">
              <thead>
                <tr>
                  <th>Name</th>
                  <th>Email</th>
                  <th>Phone</th>
                  <th>Status</th>
                  <th>Actions</th>
                </tr>
              </thead>
              <tbody>
                {fmsAccounts.map((fms) => (
                  <tr key={fms.id}>
                    <td>{fms.name}</td>
                    <td>{fms.email}</td>
                    <td>{fms.phone || "-"}</td>
                    <td>
                      <span className={`status-badge status-${fms.status.replace(/\s/g, "")}`}>
                        {fms.status}
                      </span>
                    </td>
                    <td className="action-cell">
                      {fms.status === "pending" ? (
                        <>
                          <button
                            className="btn-approve"
                            onClick={() => handleApprove(fms.id)}
                          >
                            Approve
                          </button>
                          <button
                            className="btn-reject"
                            onClick={() => handleReject(fms.id)}
                          >
                            Reject
                          </button>
                        </>
                      ) : (
                        <span>-</span>
                      )}
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        )}
      </div>
    </div>
  );
}